import React, { useState, useEffect } from "react";
import Strings from "../utils/strings";
import { Input } from "./shared/input";
import { useForm } from "react-hook-form";
import Button from "./shared/button";
import { useApi } from "../hooks/use-api";
import Loading from "./shared/loading";
import { Description } from "../styles/shared/components";
import Colors from "../utils/colors";
import { graphql, useStaticQuery } from "gatsby";
import FormPhoneSvg from "../assets/svg/sushi-form/form-phone.svg";
import FormEmailSvg from "../assets/svg/sushi-form/form-email.svg";
import FormRestaurantSvg from "../assets/svg/sushi-form/form-restaurant.svg";
import FormNameSvg from "../assets/svg/sushi-form/form-name.svg";
import HelpSvg from "../assets/svg/sushi-form/help.svg";
import Img from "gatsby-image";
import ReactTooltip from "react-tooltip";

const Form = ({ className }) => {
  const { register, errors, handleSubmit, getValues, setValue } = useForm();
  const [total, setTotal] = useState(13695);
  const [uc, setUnitCost] = useState(13.7);
  const [genericDesign, setGenericDesign] = useState(true);
  const [otherChecked, setOtherChecked] = useState(false);
  const [minNumber] = useState(1000);
  const [no, setNumber] = useState("1000");
  const [is, setIncludeStrategy] = useState(false);
  const [otherNumber, setOtherNumber] = useState();
  const [designSelected, setDesignSelected] = useState("orange");
  const { sendCotizationForm, loading, error, completed } = useApi();

  useEffect(() => {
    setValue("design", "generic");
    setValue("number", "1000");
  }, []);

  const submit = (formData) => {
    //console.log(formData);
    const finalFormData = { ...formData, unitCost: uc, total };
    sendCotizationForm(finalFormData);
  };

  const change = () => {
    //Revisa si se checkeó el campo Otro (piezas)
    const { checked } = document.querySelector("#four");
    let number = getValues("number");
    setOtherChecked(checked);
    if (checked) {
      if (otherNumber) {
        setOtherNumber(getValues("otherNumber"));
        setNumber(getValues("otherNumber"));
        number = getValues("otherNumber");
      } else {
        setOtherNumber("1500");
        setNumber("1500");
        number = 1500;
      }
    } else {
      setNumber(getValues("number"));
      setOtherNumber("");
    }

    if (getValues("includeStrategy")) {
      setIncludeStrategy(true);
    } else {
      setIncludeStrategy(false);
    }

    if (getValues("design") === "generic") {
      setGenericDesign(true);
    } else {
      setGenericDesign(false);
    }

    const contractType = getValues("contractType");
    const includeStrategy = getValues("includeStrategy");

    let unitCost = 0;
    let deliveryCost = 0;
    if (number >= 10000000) {
      setValue("number", 9999999);
    }
    switch (contractType) {
      case "unique":
        if (!includeStrategy) {
          if (number < 5000) {
            unitCost = 13.7;
          }
          if (number >= 5000 && number < 10000) {
            unitCost = 10.81;
          }
          if (number >= 10000) {
            unitCost = 9.41;
          }
        }
        if (includeStrategy) {
          if (number < 5000) {
            unitCost = 19.2;
          }
          if (number >= 5000 && number < 10000) {
            unitCost = 11.36;
          }
          if (number >= 10000) {
            unitCost = 10.38;
          }
        }
        break;
      case "quarterly":
        if (!includeStrategy) {
          if (number < 5000) {
            unitCost = 12.45;
          }
          if (number >= 5000 && number < 10000) {
            unitCost = 9.83;
          }
          if (number >= 10000) {
            unitCost = 8.55;
          }
        }
        if (includeStrategy) {
          if (number < 5000) {
            unitCost = 17.45;
          }
          if (number >= 5000 && number < 10000) {
            unitCost = 10.33;
          }
          if (number >= 10000) {
            unitCost = 9.44;
          }
        }
        break;
      default:
        return;
    }
    if (number < minNumber) {
      //setValue("number", minNumber);
    }
    setUnitCost(unitCost);
    setTotal(number * unitCost + deliveryCost);
  };

  const {
    orange: {
      childImageSharp: { fluid: imgOrange },
    },
    red: {
      childImageSharp: { fluid: imgRed },
    },
    purple: {
      childImageSharp: { fluid: imgPurple },
    },
    custom: {
      childImageSharp: { fluid: imgCustom },
    },
  } = useStaticQuery(graphql`
    query {
      orange: file(name: { eq: "orange" }) {
        childImageSharp {
          fluid(maxWidth: 100) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
      red: file(name: { eq: "red" }) {
        childImageSharp {
          fluid(maxWidth: 100) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
      purple: file(name: { eq: "purple" }) {
        childImageSharp {
          fluid(maxWidth: 100) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
      custom: file(name: { eq: "custom" }) {
        childImageSharp {
          fluid(maxWidth: 100) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
    }
  `);

  return (
    <div className={`form ${className}`}>
      {!loading && !completed && (
        <form
          onSubmit={handleSubmit(submit)}
          className={loading || completed ? "hidden" : ""}
        >
          <div>
            <h1 className="font-special-black uppercase">
              Co<span className="orange">ti</span>za tu{" "}
              <span className="orange">ser</span>vicio
            </h1>
            <div className="separator" />
            <div className="pieces">
              <span className="input-title bold">Piezas</span>
              <div className="pieces-container">
                <div className="pieces-radio">
                  <input
                    type="radio"
                    name="number"
                    className="vert"
                    id="one"
                    ref={register()}
                    onChange={change}
                    value={1000}
                  ></input>

                  <label
                    className={"bold " + (no === "1000" ? "orange" : "")}
                    htmlFor="one"
                  >
                    1,000pz
                  </label>
                </div>
                <div className="pieces-radio">
                  <input
                    type="radio"
                    className="vert"
                    name="number"
                    onChange={change}
                    id="two"
                    ref={register()}
                    value={5000}
                  ></input>
                  <label
                    className={"bold " + (no === "5000" ? "orange" : "")}
                    htmlFor="two"
                  >
                    5,000pz
                  </label>
                </div>
                <div className="pieces-radio">
                  <input
                    type="radio"
                    className="vert"
                    name="number"
                    id="three"
                    onChange={change}
                    value={10000}
                    ref={register()}
                  ></input>
                  <label
                    className={"bold " + (no === "10000" ? "orange" : "")}
                    htmlFor="three"
                  >
                    10,000pz
                  </label>
                </div>
                <div className="pieces-radio">
                  <input
                    type="radio"
                    className="vert"
                    name="number"
                    id="four"
                    value={otherNumber}
                    onChange={change}
                    ref={register()}
                  ></input>
                  <label
                    className={"bold " + (otherNumber ? "orange" : "")}
                    htmlFor="four"
                  >
                    Otro
                  </label>
                </div>
              </div>
              <span className="orange">
                Puedes personalizar tu diseño a partir de 5,000 piezas
              </span>
              {otherChecked && (
                <Input
                  label={"Número de piezas"}
                  name={"otherNumber"}
                  id={"otherNumber"}
                  type="number"
                  maxLength={7}
                  defaultValue={1500}
                  errors={errors.otherNumber}
                  onChange={change}
                  inputRef={register({
                    required: "Campo obligatorio",
                    min: {
                      value: 1000,
                      message: `El mínimo de paquetes es ${minNumber}`,
                    },
                  })}
                />
              )}
            </div>

            <div className="design">
              <span className="input-title bold">Diseño</span>
              <div className="design-radio">
                <input
                  type="radio"
                  name="design"
                  id="generic"
                  onChange={change}
                  value="generic"
                  ref={register()}
                ></input>
                <label
                  className={"bold " + (genericDesign ? "orange" : "")}
                  htmlFor="generic"
                >
                  Genérico{" "}
                  <span className={"light " + (genericDesign ? "orange" : "")}>
                    (Agrega tu logo)
                  </span>
                </label>
              </div>
              {genericDesign && (
                <div className="generic-designs">
                  <div
                    id="orange"
                    className={
                      "generic-design " +
                      (designSelected === "orange" ? "selected" : "")
                    }
                    onClick={() => {
                      setDesignSelected("orange");
                    }}
                  >
                    <Img fluid={imgOrange} style={{ minWidth: "70px" }} />
                  </div>
                  <div
                    id="red"
                    className={
                      "generic-design " +
                      (designSelected === "red" ? "selected" : "")
                    }
                    onClick={() => {
                      setDesignSelected("red");
                    }}
                  >
                    <Img fluid={imgRed} style={{ minWidth: "70px" }} />
                  </div>
                  <div
                    id="purple"
                    className={
                      "generic-design " +
                      (designSelected === "purple" ? "selected" : "")
                    }
                    onClick={() => {
                      setDesignSelected("purple");
                    }}
                  >
                    <Img fluid={imgPurple} style={{ minWidth: "70px" }} />
                  </div>
                  <input
                    type="hidden"
                    value={designSelected}
                    name="genericDesign"
                    ref={register()}
                  />
                </div>
              )}
              {no >= 5000 && (
                <>
                  <div className="design-radio">
                    <input
                      type="radio"
                      name="design"
                      id="custom"
                      value="custom"
                      onChange={change}
                      ref={register()}
                    ></input>
                    <label
                      className={"bold " + (!genericDesign ? "orange" : "")}
                      htmlFor="custom"
                    >
                      Personalizado
                    </label>
                  </div>
                  {!genericDesign && (
                    <div
                      id="custom-img"
                      className={
                        "generic-design " +
                        (getValues("design") === "custom" ? "selected" : "")
                      }
                      style={{ width: "100px" }}
                    >
                      <Img fluid={imgCustom} style={{ minWidth: "70px" }} />
                    </div>
                  )}
                </>
              )}
            </div>
            <div style={{ margin: "0 20px" }}>
              <Input
                label={"Tipo de contratación"}
                name={"contractType"}
                id={"contractType"}
                type="select"
                errors={errors.contractType}
                onChange={change}
                inputRef={register({
                  required: "Campo obligatorio",
                })}
              />
            </div>
            <div className="separator" />
          </div>
          <div className="form-data">
            {/* <input
              type="hidden"
              name="contractType"
              value="unique"
              ref={register()}
            /> */}

            <Input
              label={"Nombre"}
              name={"name"}
              id={"name"}
              type="text"
              errors={errors.name}
              Icon={FormNameSvg}
              inputRef={register({
                required: "Campo requerido",
              })}
            />
            <Input
              label={"Email"}
              name={"email"}
              id={"email"}
              Icon={FormEmailSvg}
              type="text"
              errors={errors.email}
              inputRef={register({
                required: "Campo obligatorio",
              })}
            />
            <Input
              label={"Teléfono"}
              name={"phone"}
              id={"phone"}
              Icon={FormPhoneSvg}
              type="text"
              errors={errors.phone}
              inputRef={register({
                required: "Campo obligatorio",
              })}
            />
            <Input
              label={"Restaurante"}
              name={"business"}
              id={"business"}
              Icon={FormRestaurantSvg}
              type="text"
              errors={errors.business}
              inputRef={register()}
            />
            <div
              style={{
                display: "flex",
                alignItems: "start",
                marginTop: "10px",
                justifyContent: "space-between",
              }}
            >
              <Input
                label={"Incluir estrategia digital"}
                name={"includeStrategy"}
                id={"includeStrategy"}
                type="checkbox"
                labelClass={"bold " + (is ? "orange" : "")}
                onChange={change}
                errors={errors.includeStrategy}
                inputRef={register({})}
              />
              <a
                data-tip={`<span style="color:white">Incluye: <br/>
                Estrategia de contenidos, <br/>
                Revestimiento de redes, <br/>
                Retícula para Instagram con tu nuevo empaque, <br/>
                2 gráficos para historias con tu nuevo empaque,<br/>
                Mención en nuestras campañas digitales</span>`}
                data-event="click"
                data-html={true}
                data-iscapture={true}
              >
                <HelpSvg width={20} height={20} />
              </a>
              <ReactTooltip place="top" type="dark" effect="float" />
            </div>
            {no < minNumber && (
              <span style={{ margin: "0 20px 0px 20px", color: Colors.ORANGE }}>
                El mínimo de paquetes debe ser de {minNumber}
              </span>
            )}
            {no >= minNumber && (
              <>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    padding: "10px",
                    justifyContent: "center",
                    alignItems: "end",
                    background: Colors.ORANGE,
                    borderRadius: "20px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      margin: "20px 0",
                      color: "white",
                    }}
                  >
                    <span
                      className="bold regular-font-size"
                      style={{ color: "white" }}
                    >
                      Costo unitario
                    </span>
                    <span
                      className="bold"
                      style={{ fontSize: "1.6em", color: "white" }}
                    >
                      ${uc.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      margin: "20px 0",
                    }}
                  >
                    <span className="title" style={{ color: "white" }}>
                      Total
                    </span>
                    <span
                      className="bold"
                      style={{ fontSize: "1.6em", color: "white" }}
                    >
                      ${total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    </span>
                  </div>
                </div>
                <span className="orange">* No incluye costos de envío</span>
              </>
            )}
            <Button
              backgroundColor={Colors.ORANGE}
              style={{
                color: "white",
                margin: "20px 0",
                alignSelf: "flex-end",
                justifySelf: "flex-end",
              }}
              value={Strings.CONTACT.SEND}
            />
          </div>
        </form>
      )}
      {loading && <Loading />}
      {completed && (
        <Description
          style={{
            textAlign: "center",
            color: Colors.ORANGE,
            padding: "0 30px",
            boxSizing: "border-box",
          }}
        >
          Tu cotización ha sido recibida. Alguien de nuestro equipo se pondrá
          <br />
          pronto en contacto contigo. Gracias.
        </Description>
      )}
    </div>
  );
};

export default Form;
